import { render, staticRenderFns } from "./EmptyConfiguration.vue?vue&type=template&id=53546329&scoped=true&"
import script from "./EmptyConfiguration.vue?vue&type=script&lang=js&"
export * from "./EmptyConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./EmptyConfiguration.vue?vue&type=style&index=0&id=53546329&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53546329",
  null
  
)

export default component.exports